<template>
    <div>
        <bv-top></bv-top>
        <van-list
                v-show="!noResultShow"
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                @load="onListLoad"
                :immediate-check="false"
        >
            <van-cell
                    v-for="item in list"
                    :key="item.sysGuid"
                    :title="item.title"
                    is-link
                    @click="startPublishInfo(item.sysGuid)"
            />
        </van-list>
        <van-empty v-show="noResultShow" description="没有更多内容"/>
    </div>
</template>

<script>

    import Top from '@/views/components/Top'
    import {fetchArticle} from '@/api/public/article'

    export default {
        name: 'ArticleList',
        components: {
            BvTop: Top
        },
        data() {
            return {
                smallLogo: require('@/assets/small-logo.png'),
                noResult: require('@/assets/empty.png'),
                label: decodeURIComponent(this.$route.query.label),
                value: this.$route.query.value,
                noResultShow: false,
                loading: false,
                finished: false,
                list: [],
                pageParam: {
                    pageNo: 0,
                    limit: 10
                }
            }
        },
        methods: {
            toMaintainFund() {
                this.$router.push('/maintainFund')
            },
            startPublishInfo(sysGuid) {
                this.$router.push({
                    path: '/public/articleInfo',
                    query: {
                        sysGuid: sysGuid,
                        value: this.value,
                        label: this.label
                    }
                });
            },
            onListLoad() {
                setTimeout(() => {
                    this.pageParam.pageNo = this.pageParam.pageNo + 1;
                    let params = {
                        page: this.pageParam.pageNo,
                        limit: this.pageParam.limit,
                        articleType: this.value
                    };
                    fetchArticle(params).then(res => {
                        this.list = this.list.concat(res.data.list);

                        if (res.data.total === 0) { // 查无数据
                            this.noResultShow = true
                        }

                        // 加载状态结束
                        this.loading = false;

                        // 数据全部加载完成
                        if (res.data.isLastPage) {
                            this.finished = true;
                        }
                    }).catch(() => {
                        this.error = true;
                    });
                }, 500);
            }
        },
        mounted() {
            this.onListLoad()
        }
    }
</script>